export const lingua_es = {
  lang: "es",
  title: "3D SHIRT - Configurador 3d para camisas a medida",
  description: "Configurador 3d para camisas a medida",
  personalizza: "Personalizar",
  misure: "Medidas",
  tessuto: "Tejido",
  filtri: "Filtros",
  scegliTessuto: "Elige el tejido",
  cercaTessuto: "Buscar tejido...",
  inOfferta: "En oferta",
  nonDisponibile: "No disponible",
  colore: "Color",
  colori: "Colores",
  tuttiColori: "Todos los colores",
  bianco: "Blanco",
  celeste: "Celeste",
  altriColori: "Otros colores",
  disegno: "Tejidos",
  disegni: "Tejidos",
  tuttiDisegni: "Todos los tejidos",
  tintaUnita: "Tejidos lisos",
  righe: "Tejidos a rayas",
  quadretti: "Tejidos a cuadros",
  fantasia: "Tejidos estampados ",
  materiale: "Material",
  materiali: "Materiales",
  tuttiMateriali: "Todos los materiales",
  cotone: "Algodon",
  lino: "Lino",
  brand: "Marca",
  brands: "Marcas",
  tuttiBrands: "Todas las marcas",
  codice: "Codigo",
  ordina: "Ordinar por precio",
  basso: "De màs bajo a màs alto",
  alto: "De màs alto a màs bajo",
  lato: "Vista laterale",
  front: "Vista frontale",
  retro: "Vista retro",
  piegata: "Vista piegata",
  extra: {
    tutti: "Todos los productos",
    selTaglia: "Elige la talla",
    desc: "Descripción",
    correlati: "Productos relacionados",
  },
  bubble: {
    prima: "Clicca qui per tornare alla vista camicia.",
    seconda: "Trascina con il tasto SINISTRO del mouse per ruotare la camicia",
    terza: "Trascina con il tasto DESTRO del mouse per spostare la camicia.",
    quarta: "Muovi la ROTELLINA del mouse per lo zoom.",
    quinta: "OK, CHIUDI",
    sesta: "Trascina con un dito per ruotare la camicia.",
    settima: "Trascina con due dita per spostare la camicia.",
    ottava: "Allarga o stringi con due dita per lo zoom.",
  },
  banner: {
    titolo: "Uso de Cookies",
    testo1:
      "En esta aplicación, utilizamos cookies (o tecnologías similares) para almacenar información en tu ordenador o dispositivo móvil con el fin de mejorar tu experiencia on líne. Las cookies son pequeños archivos de texto que le permiten navegar de manera eficiente, recordar sus preferencias, ayudarnos a comprender el rendimiento de la aplicación y, en general, mejorar su experiencia de usuario.",
    testo2:
      "Al cerrar este mensaje, aceptas el uso de cookies en función de sus (posibles) preferencias.",
    gestione: "Manejo de cookies",
    acconsento: "Estoy de acuerdo",
  },
  sito: {
    titolo: "La tua camicia su misura direttamente dal produttore!",
    sottotitolo:
      "La nostra è un’azienda ad impronta artigianale e negli anni ha condiviso la passione per questo lavoro con un valido gruppo di esperte lavoratrici che con grande spirito di sacrificio ha saputo mantenere i legami con le proprie radici culturali dalla forte tradizione sartoriale.",
    bottone1: "Inizia a creare la tua camicia!",
    titolo2: "Un configuratore 3D senza limiti",
    sottotitolo2:
      "La camiceria Su Misura di Lodi produce e vende per aziende e privati",
    configura: "Configura",
    titolo3: "CAPI DI VERA MODA ARTIGIANALE ITALIANA!",
    sottotitolo3:
      "Offriamo tutta la nostra esperienza per confezionare camicie di qualità interamente fatte a mano secondo la tradizione sartoriale italiana.",
    titolo4: "Qualità delle immagini",
    sottotitolo4:
      "Scegli una camicia su misura, ti garantiamo una",
    titolo5: "VESTIBILITA' PERFETTA",
    sottotitolo5:
      "ed un elevato confort perchè si tratta di un capo tagliato sulla persona in base alla corporatura e alle esigenze specifiche del cliente.",
    sottotitolo6:
      "Per la nostra produzione impieghiamo",
    titolo7: "MATERIE PRIME ECCELLENTI",
    sottotitolo7:
      "100% Cotone doppio ritorto prodotto dalle migliori aziende italiane quali: Albini, Canclini, Canaloni, Monti, Ibieffe, Fratelli Tosetti, Reda e Rubinelli.",
    titolo8: "Senza limiti...",
    sottotitolo8:
      "Bottoni di ottima madreperla, Pvc riciclato e Corozo cuciti sapientemente con cotoni e sete di filati Guttermann e Maidera.",
    titolo9: " Web Marketing",
    sottotitolo9:
      "Continua evoluzione di materiali ecosostenibili.",
    titolo10: "Caratteristiche del configuratore 3D SHIRT",
    sottotitolo10:
      "Tutta la versatilità di una camicia... perfetta in ogni occasione!",
    titolo11: "AMPIA SCELTA",
    sottotitolo11:
      "Privilegia il look che più ti rappresenta! Potrai scegliere il tuo stile tra il vasto assortimento di tessuti e le diverse tipologie di finiture.",
    titolo12: "I NOSTRI SERVIZI",
    serv1tit:"CONTATTO",
    serv2tit:"PRESA IN CARICO ORDINE",
    serv3tit:"CONFEZIONAMENTO",
    serv1des:"Seguiamo il cliente passo dopo passo, dalla presa delle misure alla scelta delle finiture, per realizzare il prodotto che più soddisfi le esigenze richieste.",
    serv2des:"Una modellista esperta prepara e sviluppa il cartamodello della camicia da cui parte il processo di produzione, svolto interamente a mano in ogni passaggio.",
    serv3des:"Una artigiana professionista si occupa della realizzazione del capo avendo cura di ogni singolo dettaglio come le cuciture realizzate a mano.",
    sottotitolo12:
      "L'applicazione è in grado di gestire tutte le fasi del processo d'acquisto, dalla gestione del carrello, e quindi prodotti e codici sconto, fino alla gestione della spedizione e del pagamento.",
    titolo13: "Creazione Account",
    sottotitolo13:
      "L'applicazione prevede la possibilità di creare un profilo utente personale che permetterà all'utente stesso di memorizzare le proprie misure e i propri acquisti.",
    newshop:
      "Da oggi 3D SHIRT permette la vendita di prodotti collegati alla tua sartoria! Non solo camicie personalizzate ma anche camicie pronte, cravatte o quello che vuoi!",
  },
  contact: {
    titolo: "Envianos un mensaje",
    sottotitolo:
      "Contáctenos para solicitar una cotización o simplemente para preguntas o sugerencias relacionadas con una posible solicitud. Intentaremos responderte lo antes posible.",
    nome: "Tu nombre",
    telefono: "Su telefono",
    email: "Su correo electronico",
    messaggio: "Deja un mensaje",
    invia: "Enviar el mensaje",
  },
  header: {
    account: "Account",
    modificapassword: "Cambiar Contraseña",
    logout: "Logout",
    wishlist: "Lista de Deseos",
    shopping: "Cesta de Compra",
    loggedOut: "Ya no estás conectado.",
    loggedOutError: "Ha ocurrido un error:",
    cambiaPasswordSuccess:
      "Le enviaremos un correo electrónico con un enlace único para restablecer su contraseña.",
    cambiaPasswordError: "Ha ocurrido el siguiente error:",
  },
  coloriTip: {
    grigio: "Gris",
    blu: "Azul",
    nero: "Negro",
    marrone: "Marrón",
    verde: "Verde",
    bianco: "Blanco",
    viola: "Viola",
    arancione: "Naranja",
    beige: "Beige",
    giallo: "Amarillo",
    rosa: "Rosa",
    rosso: "Rojo",
  },
  footer: {
    account: "Account",
    login: "Login",
    logout: "Logout",
    cookie: "Cookie Policy",
    privacy: "Privacy Policy",
    termini: "Términos y Condiciones",
    recesso: "Derecho de Anular",
    contattaci: "Contáctenos",
    partita: "P.IVA",
  },
  dettaglio: {
    descrizione: "Descripción del tejido",
    comeMisure: "Cómo tomar medididas",
    spedizione: "Envío y devolución",
  },
  navigazione: {
    lang: "es",
    tessuto: "Tejido",
    scegliTessuto: "Elige el tejido",
    inOfferta: "En oferta",
    nonDisponibile: "No disponible",
    personalizza: "Personalizar",
    personalizzazione: "Personalización",
    polsinoGemelli: "Puño gemelos",
    contrastoColletto: "Aplicar al cuello",
    contrastoPolsino: "Aplicar al puño",
    contrastoChiusura: "Aplicar à la cierre",
    chiusura: "Cierre",
    colletto: "Cuello",
    polsino: "Puño",
    taschino: "Bolsillos",
    pinces: "Pinzas",
    asole: "Ojal",
    bottoni: "Botons",
    fili: "Hilo",
    contrasto: "Contraste",
    loading: "Cargando...",
    mascherina: "Mascarilla",
    maniche: "Mangas",
    durezzaTitolo: "Dureza del cuello",
    durezza1: "Rigido",
    durezza2: "Normal",
    durezza3: "Suave",
    durezza4: "Super Suave",
    velaTitolo: "Pala",
    vela1: "Pala 7",
    vela2: "Pala 7.5",
    vela3: "Pala 8",
    vela4: "Pala 8.5",
    vela5: "Pala 9",
    vela6: "Cuello espaciado",
    fondo: {
      titolo: "Fondo Camicia",
      classico: "Classico",
      dritto: "Dritto",
      drittoSpacchi: "Dritto con spacchi",
    },
    iniziali: {
      iniziali: "Iniciales",
      inserisciIniziali: "Entrez vos Iniciales",
      tueIniziali: "Entrez vos Iniciales",
      stile: "Estilo Iniciales",
      colore: "Color Iniciales",
      bianco: "Blanco",
      blu: "Azul",
      celeste: "Celeste",
      grigio: "Gris",
      nero: "Negro",
      rosso: "Rojo",
      verde: "Verde",
      arancione: "Naranja",
      rosa: "Rosada",
      posizione: "Posición iniciales",
      sopra: "Arriba",
      centro: "Centro",
      sotto: "Abajo",
      polsinoSx: "Puño izquierdo",
      polsinoDx: "Puño derecho",
      stile1: "style",
      colore1: "color",
      posizione1: "position",
    },
    misure: {
      misuraNeutra: "Camisa de prueba",
      misuraNeutraTitolo: "¿Quieres probarte la camisa antes de comprarla?",
      misuraNeutraTesto1:
        "Solicite una camisa neutra en las tallas seleccionadas, a un precio de solo 20,00 €.",
      misuraNeutraTesto2:
        "El costo de la camisa de prueba se descontará más adelante en el pedido final.",
      metodoTitolo: "Selecciona tu método",
      metodoTaglia: "Mediciones de tallas estándar",
      metodoCorpo: "Mide tu cuerpo",
      metodoCamicia: "Mide una camisa que te quede bien",
      metodoInvia: "Envíanos una camisa para medirla",
      metodoModifica: "Editar",
      metodoInformazioni: "Información",
      selezionaTaglia: "Selecciona tu talla...",
      selezionaVestibilita: "Selecciona tu ajuste...",
      selezionaCorporatura: "Seleccione su construcción...",
      selezionaSpalle: "Seleccione el descenso del hombro...",
      corporatura: {
        pancia: {
          nome: "Pancia",
          piatta: "Plano",
          regolare: "Regular",
          sporgente: "Abultada",
        },
        spalle: {
          nome: "Spalle",
          alte: "Altos",
          regolari: "Regulares",
          basse: "Bajos",
        },
      },

      taglie: "TALLAS",
      Vita: "Cintura",
      lunghezzaCam: "Longitud",

      misure: "Medidas",
      tueMisure: "Tus medidas",
      salva: "Guardar tus medidas",
      errore: "Error al cargar",
      successo: "Medidas cargadas con éxito",
      Braccia: "Manga",
      Bicipite: "Bíceps",
      Avambraccio: "Avambraccio",
      PuntoVitaDietro: "Punto vita dietro",
      LunghezzaDavanti: "Lunghezza Davanti",
      MezzoTorace: "Mezzo Torace",
      PuntoTorace: "Punto Torace",
      MezzaManica: "Mezza Manica",
      Collo: "Cuello",
      Girovita: "Cintura",
      Polso: "Puño ",
      Spalle: "Hombros",
      Torace: "Pecho",
      Lunghezza: "Largo",
      ColloSpalla: "Collo Spalla",
      PettoGiro: "Petto Giro",
      PettoSpalla: "Petto Spalla",
      fianco: "Fianco",
      giroManica: "Giro Manica",
      dimColloSpalla: "Cuello - Hombros",
      PettoGiro: "Redondo Pecho",
      ColloSpalla: "Cuello - Tamano de Hombro",
      fianco: "Medida Lateral",
      giroManica: "Brazo",
      vuoiAiuto: "Quieres ayuda con las medidas?",
      provaSelezionare: "Seleccionar tu talla",
      successoCarica: "Medidas cargadas con éxito",
      seleziona: "Seleccionar...",
      xs: "XS - 36",
      s: "S - 37/38",
      m: "M - 39/40",
      l: "L - 41/42",
      xl: "XL - 43/44",
      xxl: "XXL - 45/46",
      xxxl: "XXXL - 47/48",
      oppure: "o",
      stoCaricando: "Cargando...",
      carica: "Sube tus medidas",
      inviaTitolo: "Envíanos la camisa a medir",
      inviaParag1:
        "¿Desea duplicar las medidas de una camisa en su posesión, pero no sabe cómo medirla correctamente?",
      inviaParag2:
        "Envíenos su camisa y nuestros expertos la medirán y guardarán sus medidas para futuras compras. * Tenga en cuenta que no se dañará su camisa y se la enviaremos de la mejor manera posible.",
      inviaParag3: "Enviar a:",
      inviaTitolo2: "Al enviar, asegúrese de incluir:",
      inviaLista1: "La camisa que quieres que midamos",
      inviaLista2: "Tu nombre",
      inviaLista3: "Un número de teléfono",
      inviaLista4: "Su dirección de correo electrónico",
      inviaLista5: "La dirección de envío",
      inviaLista6: "Cualquier instrucción especial",
      infoTipoMisure: "Tipo de medidas:",
      infoTipoMisure0: "medidas por talla",
      infoTipoMisure1: "medidas del cuerpo",
      infoTipoMisure2: "medidas de la camisa",
      infoTipoMisure3: "Enviaré una camisa a medida",
      infoTagliaSelezionata: "Talla seleccionada:",
      infoVestibilita: "Ajuste",
      aggiungiIniziali: "Agregar iniciales",
      stile1: "estilo",
      colore1: "colore",
      posizione1: "ubicación",
    },
  },
  barraAcquisto: {
    lang: "es",
    nonDisponibile: "Tejido no disponible.",
    tooltip: "Añadir esta camisa a la Cesta de Compra",
    carrello: "Añadir a la Cesta de Compra",
    camicia: "Camisa ",
    tessuto: "Tejido ",
    di: " de",
    aggiunta: "Camisa añadida a la Cesta de Compra",
    aggiunta1: "Camisa añadida con éxito a la Cesta de Compra.",
    aggiunta2: "¿Qué quieres hacer ahora?",
    continua: "Continúa con tus compras",
    vai: "Ir a la Cesta de Compra",
    wishlist: {
      lang: "es",
      nuovoPrezzo: "Nuevo precio",
      nonDisponibile: "Atención, tejido no disponible!",
      wishlist: "Lista de Deseos",
      vuota: "Tu lista de deseos está vacía.",
      Camicia: "Camisa",
      tooltip: "Agregar la camisa a la Wishlist",
      successo: "Camiseta agregada con éxito a la Wishlist.",
      rimossa: "Camiseta eliminada con éxito de la Wishlist.",
      Prodotto: "Producto",
      Prezzo: "Precio",
      Descrizione: "Descripción",
      Tessuto: "Tela",
      Disegno: "Dibujo",
      Colletto: "Cuello",
      Italiano: "Italiano",
      "Italiano Classico": "Italiano clásico",
      "Francese Classico": "Francés clásico",
      "Francese Semiaperto": "Semi-abierto francés",
      "Francese Semiaperto due bottoni": "Semi-abierto frances dos botones",
      "Botton Down Classico": "Button Down",
      "Botton Down alto due bottoni": "Button Down alto dos botones",
      Diplomatico: "Diplomático",
      Coreano: "Coreano",
      "Polsino arrotondato": "Puño redondeado",
      "Polsino smussato ": "Puño biselado",
      "Polsino gemelli": "Puño gemelos",
      "Manica corta": "Manga corta",
      Chiusura: "Cierre",
      "Faldoncino interno non Impunturato": "francés",
      "Faldoncino Esterno Impunturato": "Estándar",
      "Finta Doppia e bottoni nascosti": "Oculto",
      "Nessun Taschino": "No bolsillo",
      "Taschino arrotondato": "Bolsillo redondeado",
      "Taschino smussato": "Bolsillo biselado",
      "Dos taschini arrotondati": "Dos bolsillos redondeados",
      "Due taschini smussati": "Dos bolsollos biselados",
      "Dietro liscio": "Detrás liso",
      "Dietro con doppie pinces": "Detrás con pinzas dobles",
      "Dietro con doppia piega": "Detrás con pinza central",
      "Asola bianca": "Ojal blanco",
      "Asola blu": "Ojal azul",
      "Asola celeste": "Ojal celeste",
      "Asola grigia": "Ojal gris",
      "Asola nera ": "Ojal negro",
      "Asola rossa": "Ojal rojo",
      "Bottone bianco": "Botones blanco",
      "Bottone blu": "Botones azul",
      "Bottone celeste": "Botones celeste",
      "Bottone grigio": "Botones gris",
      "Bottone nero": "Botones nero",
      "Bottone rosso": "Botones rojo",
      "Filo bianco": "Hilo blanco",
      "Filo blu": "Hilo azul",
      "Filo celeste": "Hilo celeste",
      "Filo grigio": "Hilo gris",
      "Filo nero": "Hilo negro",
      "Filo rosso": "Hilo rojo",
      Contrasto: "Contraste",
      contrastoPolsino: "Puño",
      contrastoColletto: "Cuello",
      contrastoChiusura: "Cierre",
      Stile: "Estilo",
      Iniziali: "Iniciales",
      iniStile: "Estilo",
      iniColore: "Color",
      iniPosizione: "Posición",
      white: "Blanco",
      slateblue: "Azul",
      lightsteelblue: "Celeste",
      lightgray: "Grey",
      black: "Negro",
      crimson: "Rojo",
      posizione: "Elegir posición",
      sopra: "Arriba",
      centro: "Centro",
      sotto: "Abajo",
      rimuovi: "Eliminar de la Wishlist",
      importa: "Importar en el configurador",
      torna: "Volver al configurador",
    },
  },
  tutorial: {
    braccia: {
      header: "Manga",
      titolo: "Manga",
      descrizione:
        "Medir la manga desde el principio del hombro hasta la muñeca doblando el brazo a 90°.",
    },
    mezzaManica: {
      header: "Mezza Manica",
      titolo: "Misura della mezza manica",
      descrizione:
        "Misura la manica dalla spalla sino alla lunghezza desiderata per un minimo di 18cm e un massimo di 30cm",
    },
    bicipite: {
      header: "Biceps",
      titolo: "Medición de bíceps",
      descrizione:
        "Medir los bíceps/tríceps en cm. 16 a partir de la punta exterior del hombro.",
    },
    avambraccio: {
      header: "avambraccio",
      titolo: "Misura dell'avambraccio",
      descrizione: "Misura l'avambraccio appena sotto il gomito.",
    },
    fianco: {
      header: "Fianco",
      titolo: "Misura del Fianco",
      descrizione:
        "Misura il fianco all'altezza della fine della tasca dei pantaloni passando per l'altezza a meta' dei glutei.",
    },
    puntoVitaDietro: {
      header: "Fianco",
      titolo: "Misura del punto vita dietro",
      descrizione:
        "Misura partendo dall'attaccatura dietro del collo fino ad intercettare il punto più stretto in vita ( misure slim).",
    },
    mezzoTorace: {
      header: "mezzo torace",
      titolo: "Misura del mezzo torace",
      descrizione:
        "Misura la distanza (indossando una camicia ) tra l'attaccatura del carrè al collo scendendo verso il basso (per persone corpulente). ",
    },
    puntoTorace: {
      header: "punto torace",
      titolo: "Misura del punto torace",
      descrizione:
        "Misura dall'attaccatura del carrè al collo fino al capezzolo sul torace ( determina l'altezza del torace).",
    },
    bracciaCamicia: {
      header: "Brazos",
      titolo: "Medidas de los Brazos",
      descrizione:
        "Mida la manga desde la costura más alta del hombro hasta el extremo del puño, manteniendo la camisa plana sobre una superficie plana.",
    },
    collo: {
      header: "Cuello",
      titolo: "Medidas del cuello",
      descrizione:
        "Pase la cinta métrica alrededor del cuello y mida justo debajo de la nuez de Adán. Es importante insertar un dedo entre la cinta métrica y el cuello para asegurar un ajuste cómodo.",
    },
    colloCamicia: {
      header: "Cuello",
      titolo: "Medidas del cuello",
      descrizione:
        "Mida la distancia lineal entre el botón del collar y el ojal correspondiente, manteniendo el collar abierto y acostado sobre una superficie plana.",
    },
    girovita: {
      header: "Cintura",
      titolo: "Medida de cintura",
      descrizione:
        "Medir la circunferencia de la cintura en el punto más ancho a la altura del ombligo, dejando un dedo de tolerancia entre el cuerpo y el metro, para poder sentarse cómodamente. Es importante tomar la medida precisa, manteniendo el metro adherido al cuerpo.",
    },
    girovitaCamicia: {
      header: "Cintura",
      titolo: "Medida de cintura",
      descrizione:
        "Mida la cintura en el punto más ancho del ombligo, entre el segundo y el tercer botón desde la parte inferior, manteniendo la camisa plana sobre una superficie plana. Si tiene caderas anchas, es recomendable tomar la medida un poco más abajo. para entenderlos en total.",
    },
    polso: {
      header: "Puño",
      titolo: "Medidas del puño",
      descrizione:
        "Medir la circunferencia de la muñeca a la altura de la articulación.",
    },
    polsoCamicia: {
      header: "Puño",
      titolo: "Medidas del puño",
      descrizione:
        "Mida la distancia lineal entre el botón del puño y el ojal correspondiente, manteniendo el puño abierto y acostado sobre una superficie plana.",
    },
    spalle: {
      header: "Hombros",
      titolo: "Medidas de los hombros",
      descrizione: "Medir el ancho de los hombros en el punto más ancho.",
    },
    spalleCamicia: {
      header: "Hombros",
      titolo: "Medidas de los hombros",
      descrizione:
        "Mida los hombros en el punto más ancho, desde la costura superior del brazo izquierdo hasta la del brazo derecho, manteniendo la camisa plana sobre una superficie plana.",
    },
    torace: {
      header: "Torax",
      titolo: "Medidas del torax",
      descrizione:
        "Medir la circunferencia del torax al nivel del pecho, siempre manteniendo un dedo de tolerancia entre el cuerpo y el metro para que pueda moverse con libertad.",
    },
    toraceCamicia: {
      header: "Torax",
      titolo: "Medidas del torax",
      descrizione:
        "Mida la circunferencia del pecho entre el segundo y el tercer botón desde arriba. Mida la distancia lineal entre el botón y el ojal correspondiente opuesto.",
    },
    lunghezza: {
      header: "Largo",
      titolo: "Largo",
      descrizione:
        "Incline su cabeza hacia adelante y mida desde el centro de la base trasera del cuello hasta la entrepierna del pantalón.",
    },
    lunghezzaCamicia: {
      header: "Longitud",
      titolo: "Medidas de longitud",
      descrizione:
        "Manteniendo la camisa plana sobre una superficie plana, mida desde el centro de la base posterior del cuello, en el centro de la costura entre la camisa y el cuello, hasta el dobladillo inferior.",
    },
    colloSpalla: {
      header: "Cuello - Hombros",
      titolo: "Cuello - Hombros",
      descrizione:
        "Mida la distancia desde la unión del cuello hasta el final del hombro. Es importante determinar si desea un hombro preciso 'a la medida' o casual 'Large'.",
    },
    pettoGiro: {
      header: "Redondo Pecho",
      titolo: "Redondo Pecho",
      descrizione:
        "Mida el frente entre el segundo y el tercero botones hasta la costura de la manga.",
    },
    pettoSpalla: {
      header: "Medida pecho-hombro",
      titolo: "Medida pecho-hombro",
      descrizione:
        "Mide desde el pecho hasta la costura de la manga con el hombro.",
    },
    fianco: {
      header: "Medida de la cadera",
      titolo: "Medida de la cadera ",
      descrizione: "Medir la cadera en el punto más ancho.",
    },
    giroManica: {
      header: "Medida de la sisa",
      titolo: "Medida de la sisa",
      descrizione:
        "Mide las sisas a la altura de los hombros, dejando un dedo entre la cinta métrica y el brazo.",
    },
  },
  contatti: {
    richiesto: "Campo obligatorio",
    emailInvalida: "Dirección de correo electrónico no válida",
    titolo: "Nos encanta hablar contigo",
    successo: "Gracias. Su mensaje ha sido enviado con éxito.",
    errore: "Cuidado. Ha ocurrido un error.",
    nome: "Nombre *",
    email: "Email *",
    oggetto: "Sujeto *",
    messaggio: "Mensaje *",
    attendere: "Esperar...",
    invia: "Enviar",
    testo01:
      "CADA PEDIDO REQUIERE AL MENOS 20 DÍAS LABORABLES ANTES DEL ENVÍO. Nos disculpamos por esta molestia, pero su camisa no será como todas las demás.",
    testo02:
      "Sartoria Turrisi se encuentra en Ceglie Messapica, una ciudad acogedora en la provincia de Brindisi, en el sur de Puglia.",
    testo03:
      "Desde 1970, nuestra sólida tradición de vestimenta se ha transmitido de padres a hijos: somos una pequeña empresa artesanal que opera con pasión en cada etapa de la producción, que se lleva a cabo exclusivamente en nuestra sastrería por artesanos italianos altamente especializados.",
    testo04:
      'La elección de telas y accesorios de la más alta calidad nos permite ofrecer la excelencia del auténtico "Made in Italy".',
    testo05:
      "Nuestro objetivo es satisfacer a nuestros clientes en todos los aspectos, poniendo nuestra larga experiencia a su disposición.",
    testo06:
      "Hoy es posible confundir a un escultor con un sastre, porque ambos crean formas.",
    testo07: "KARL KRAUS",
    testo08: "Puedes apreciar la calidad de nuestros tejidos con TUS MANOS¡",
    testo09: "PIDE TU KIT GRATIS AHORA!",
  },
  pagina404: {
    errore: "Error 404",
    nonEsiste: "¡La página que buscas no existe!",
    torna: "Volver al configurador",
  },
};
